export default "__VITE_ASSET__eNm3a8yO__"